import { createSlice } from '@reduxjs/toolkit';

import {
  createStudent,
  getStudents,
  getSchoolStudents,
  finishImportStudents,
  removeStudentById,
} from './actions';

const initialState = {
  data: [] as any[],
  currentPage: 1,
  perPage: 10,
  totalPages: null as any,
};

const studentsSlice = createSlice({
  name: 'students',
  initialState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder.addCase(getStudents.fulfilled, (_: any, action: any) => {
      return action.payload;
    });

    builder.addCase(getSchoolStudents.fulfilled, (_: any, action: any) => {
      return action.payload;
    });

    builder.addCase(createStudent.fulfilled, (state: any, action: any) => {
      const existingStudent = state.data.some(
        (student: any) => student.id === action.payload.id,
      );

      return {
        ...state,
        data: existingStudent
          ? state.data.map((student: any) => {
              if (student.id === action.payload.id) {
                return action.payload;
              }

              return student;
            })
          : [...state.data, action.payload],
      };
    });

    builder.addCase(
      finishImportStudents.fulfilled,
      (state: any, action: any) => {
        return {
          ...state,
          data: [...state.data, ...action.payload],
        };
      },
    );

    builder.addCase(removeStudentById, (state: any, action: any) => {
      return {
        ...state,
        data: state.data.filter(
          (student: any) => student.id !== action.payload,
        ),
      };
    });
  },
});

export default studentsSlice.reducer;
